{
  "level": "sky",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:sky",
    "objects": "AREAS.E3:sky.e3",
    "mesh": "TREES.E3:sky.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -0.9548166394233704,
        -0.15122810006141663,
        -0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.683573305606842,
        -0.683573305606842,
        -0.2558423578739166
      ],
      "plane_d": 1909.6334228515625,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.15122810006141663,
        -0.9548166394233704,
        -0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15122810006141663,
        -0.9548166394233704,
        -0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.683573305606842,
        -0.683573305606842,
        -0.2558423578739166
      ],
      "plane_d": 1909.633544921875,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9548165798187256,
        -0.15122808516025543,
        -0.25584232807159424
      ],
      "plane_d": 1909.6331787109375,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9548166394233704,
        0.15122810006141663,
        -0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.683573305606842,
        0.683573305606842,
        -0.2558423578739166
      ],
      "plane_d": 1909.6334228515625,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15122810006141663,
        0.9548166394233704,
        -0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.15122810006141663,
        0.9548166394233704,
        -0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.683573305606842,
        0.683573305606842,
        -0.2558423578739166
      ],
      "plane_d": 1909.633544921875,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9548166394233704,
        0.15122810006141663,
        -0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9548166394233704,
        -0.15122810006141663,
        0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6835732460021973,
        -0.6835732460021973,
        0.25584232807159424
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.15122808516025543,
        -0.9548165798187256,
        0.25584232807159424
      ],
      "plane_d": 1909.633056640625,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15122810006141663,
        -0.9548166394233704,
        0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        2000.0,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.683573305606842,
        -0.683573305606842,
        0.2558423578739166
      ],
      "plane_d": 1909.6334228515625,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9548165798187256,
        -0.15122808516025543,
        0.25584232807159424
      ],
      "plane_d": 1909.633056640625,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9548166394233704,
        0.15122810006141663,
        0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -2000.0,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6835732460021973,
        0.6835732460021973,
        0.25584232807159424
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15122808516025543,
        0.9548165798187256,
        0.25584232807159424
      ],
      "plane_d": 1909.633056640625,
      "bbox_min": [
        -1902.113037109375,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.15122810006141663,
        0.9548166394233704,
        0.2558423578739166
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -2000.0,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.683573305606842,
        0.683573305606842,
        0.2558423578739166
      ],
      "plane_d": 1909.6334228515625,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9548165798187256,
        0.15122808516025543,
        0.25584232807159424
      ],
      "plane_d": 1909.633056640625,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        2000.0,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8613525629043579,
        -0.4388810098171234,
        0.255842387676239
      ],
      "plane_d": 1909.6334228515625,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.438880980014801,
        -0.8613525629043579,
        0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4388810098171234,
        -0.8613525629043579,
        0.255842387676239
      ],
      "plane_d": 1909.6334228515625,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8613525629043579,
        -0.438880980014801,
        0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8613525629043579,
        0.4388810098171234,
        0.255842387676239
      ],
      "plane_d": 1909.6334228515625,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.438880980014801,
        0.8613525629043579,
        0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4388810098171234,
        0.8613525629043579,
        0.255842387676239
      ],
      "plane_d": 1909.6334228515625,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8613525629043579,
        0.438880980014801,
        0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8613525629043579,
        -0.4388810098171234,
        -0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.438880980014801,
        -0.8613525629043579,
        -0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4388810098171234,
        -0.8613525629043579,
        -0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1902.113037109375,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8613525629043579,
        -0.438880980014801,
        -0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8613525629043579,
        0.4388810098171234,
        -0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1902.113037109375,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.438880980014801,
        0.8613525629043579,
        -0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1732.05078125,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4388810098171234,
        0.8613525629043579,
        -0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1732.05078125,
        -1902.113037109375,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8613525629043579,
        0.438880980014801,
        -0.255842387676239
      ],
      "plane_d": 1909.63330078125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1902.113037109375,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.702713131904602,
        -0.11129879206418991,
        -0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.503087043762207,
        -0.503087043762207,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.32300180196762085,
        -0.6339266896247864,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11129879206418991,
        -0.702713131904602,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.11129879206418991,
        -0.702713131904602,
        -0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.503087043762207,
        -0.503087043762207,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6339266896247864,
        -0.32300180196762085,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.702713131904602,
        -0.11129879206418991,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.702713131904602,
        0.11129879206418991,
        -0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.503087043762207,
        0.503087043762207,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2586025595664978,
        -0.04095861688256264,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2332887053489685,
        -0.11886652559041977,
        -0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18513897061347961,
        -0.18513897061347961,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11886652559041977,
        -0.2332887053489685,
        -0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04095861688256264,
        -0.2586025595664978,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04095861688256264,
        -0.2586025595664978,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11886652559041977,
        -0.2332887053489685,
        -0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18513897061347961,
        -0.18513897061347961,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2332887053489685,
        -0.11886652559041977,
        -0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2586025595664978,
        -0.04095861688256264,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2586025595664978,
        0.04095861688256264,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2332887053489685,
        0.11886652559041977,
        -0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18513897061347961,
        0.18513897061347961,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11886652559041977,
        0.2332887053489685,
        -0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04095861688256264,
        0.2586025595664978,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04095861688256264,
        0.2586025595664978,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11886652559041977,
        0.2332887053489685,
        -0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18513897061347961,
        0.18513897061347961,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2332887053489685,
        0.11886652559041977,
        -0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2586025595664978,
        0.04095861688256264,
        -0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        2000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6339266896247864,
        -0.32300180196762085,
        -0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.32300180196762085,
        -0.6339266896247864,
        -0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6339266896247864,
        0.32300180196762085,
        -0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.32300180196762085,
        0.6339266896247864,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1112988293170929,
        0.7027131915092468,
        -0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1112988293170929,
        0.7027131915092468,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.32300180196762085,
        0.6339266896247864,
        -0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.503087043762207,
        0.503087043762207,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6339266896247864,
        0.32300180196762085,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.702713131904602,
        0.11129879206418991,
        -0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        1732.050048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7027131915092468,
        -0.1112988293170929,
        0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6339266896247864,
        -0.3230017125606537,
        0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.503087043762207,
        -0.503087043762207,
        0.7027139067649841
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3230017125606537,
        -0.6339266896247864,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1112988293170929,
        -0.7027131915092468,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1112988293170929,
        -0.7027131915092468,
        0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1732.05078125,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3230017125606537,
        -0.6339266896247864,
        0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1647.2781982421875,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.503087043762207,
        -0.503087043762207,
        0.7027139067649841
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1401.258544921875,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6339266896247864,
        -0.3230017125606537,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1018.0739135742188,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7027131915092468,
        -0.1112988293170929,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.702713131904602,
        0.11129879206418991,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1732.05078125,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6339266896247864,
        0.3230017125606537,
        0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1647.2781982421875,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.503087043762207,
        0.503087043762207,
        0.7027139067649841
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1401.258544921875,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3230017125606537,
        0.6339266896247864,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1018.0739135742188,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.11129879206418991,
        0.702713131904602,
        0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1000.0,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11129879206418991,
        0.702713131904602,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1000.0,
        -1732.05078125,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3230017125606537,
        0.6339266896247864,
        0.7027138471603394
      ],
      "plane_d": 1919.8487548828125,
      "bbox_min": [
        -1000.0,
        -1647.2781982421875,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.503087043762207,
        0.503087043762207,
        0.7027139067649841
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1000.0,
        -1401.258544921875,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6339266896247864,
        0.3230017125606537,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1000.0,
        -1018.0739135742188,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7027131915092468,
        0.1112988293170929,
        0.7027138471603394
      ],
      "plane_d": 1919.8486328125,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1732.05078125,
        1000.0,
        -1000.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2586025595664978,
        -0.04095861688256264,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        1000.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2332887053489685,
        -0.11886652559041977,
        0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        1000.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18513897061347961,
        -0.18513897061347961,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        1000.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11886652559041977,
        -0.2332887053489685,
        0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        1000.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04095861688256264,
        -0.2586025595664978,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        1000.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04095861688256264,
        -0.2586025595664978,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        1000.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11886652559041977,
        -0.2332887053489685,
        0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        951.0565185546875,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18513897061347961,
        -0.18513897061347961,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        809.0170288085938,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2332887053489685,
        -0.11886652559041977,
        0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        587.7852172851562,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2586025595664978,
        -0.04095861688256264,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        309.0169982910156,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2586025595664978,
        0.04095861688256264,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1000.0,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        8.97931897725357e-08,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2332887053489685,
        0.11886652559041977,
        0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -951.0565185546875,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18513897061347961,
        0.18513897061347961,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -809.0170288085938,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11886652559041977,
        0.2332887053489685,
        0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        -587.7852172851562,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04095861688256264,
        0.2586025595664978,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -309.0169982910156,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04095861688256264,
        0.2586025595664978,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        -1.3468977044794883e-07,
        -1000.0,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11886652559041977,
        0.2332887053489685,
        0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        0.0,
        -951.0565185546875,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18513897061347961,
        0.18513897061347961,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        0.0,
        -809.0170288085938,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2332887053489685,
        0.11886652559041977,
        0.9651150107383728
      ],
      "plane_d": 1930.22998046875,
      "bbox_min": [
        0.0,
        -587.7852172851562,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2586025595664978,
        0.04095861688256264,
        0.9651150703430176
      ],
      "plane_d": 1930.2301025390625,
      "bbox_min": [
        0.0,
        -309.0169982910156,
        -2000.0
      ],
      "bbox_max": [
        1000.0,
        0.0,
        -1732.050048828125
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}